// Form #11: Drug & Alcohol Policy. Same fields as the other policy forms
// (name, position, signature); the wording is the legacy PL Hub policy
// (translation.json employeeForms.policies.drugAlcohol).
import React from 'react';
import SimplePolicyForm from './SimplePolicyForm';

const DrugAlcoholPolicyForm = (props) => (
  <SimplePolicyForm {...props} policyKey="drugAlcohol" />
);

export default DrugAlcoholPolicyForm;
